import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TriangleDown } from "@air/next-icons";
import { memo } from "react";
import { AnnotationColorSelect } from "~/components/AssetModal/AssetModalFooter/AnnotationsToggle/AnnotateUtilsPanel/PencilUtils/SizeAndColorSelector/components/AnnotationColorSelect";
import { AnnotationSizeSelect } from "~/components/AssetModal/AssetModalFooter/AnnotationsToggle/AnnotateUtilsPanel/PencilUtils/SizeAndColorSelector/components/AnnotationSizeSelect";
export const SizeAndColorSelect = /*#__PURE__*/ memo((param)=>{
    let { selectedSize, selectedColor, setSize, setColor } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col items-center",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center rounded-2 bg-white px-1 shadow-popover",
                children: [
                    /*#__PURE__*/ _jsx(AnnotationColorSelect, {
                        setColor: setColor,
                        selectedColor: selectedColor
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "h-10 w-px bg-pigeon-50"
                    }),
                    /*#__PURE__*/ _jsx(AnnotationSizeSelect, {
                        selectedSize: selectedSize,
                        setSize: setSize
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(TriangleDown, {
                className: "-mt-4 w-8 text-white"
            })
        ]
    });
});
SizeAndColorSelect.displayName = "SizeAndColorSelector";
